import {Popper} from 'popper-vue'
import 'popper-vue/dist/popper-vue.css'
import Vue from "vue";

Vue.component('Popper', Popper)
